// extracted by mini-css-extract-plugin
export var headerCell = "_4z-1";
export var loadingSpinnerContainer = "_4z-4";
export var rowWrapper = "_4z-3";
export var standaloneTable = "_4z-5";
export var table = "_4z-0";
export var white = "_4z-2";